import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography, Button, Card, CardHeader, CardContent, Table, TableRow, TableCell, Grid } from '@material-ui/core';
import { CheckCircleOutlineOutlined } from '@material-ui/icons';
import { genfunction } from '../../../helpers'
import theme from '../../../theme'
import DataAccess from '../../../api/constants';
import Moment from 'moment';
import { actionResetBookingTypes } from 'actions';
import { useDispatch, useSelector } from 'react-redux';

const { BookingCancelMsg, BookingSuccessfullyUpdate, CustomMessageforconfirmpage, BookingTypeBarcodeHeader, TransactionCompleteTitle, ConfirmationReceiptMessage,
    ShowReadableBarcode } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    center: {
        position: "relative",
        margin: "auto",
        maxWidth: "550px"
    },
    diplaynone: {
        display: "none"
    },
    textaligncenter: {
        textAlign: "center"
    },
    headerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        textAlign: "left"
    },
    footerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        textAlign: "left",
        padding: "16px"
    },
    headertext: {
        marginTop: "8px",
        marginRight: "10px"
    },
    image: {
        border: "5px solid white"
    },
    receiptfileds: {
        textAlign: "left"
    },
    ReceiptTableCell: {
        'border-bottom': '0px solid #000 !important',
        fontSize: '16px !important',
        padding: '5px !important'
    }

}));

const PaymentCompletePage = props => {
    const { isshow, transaction } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const Payment = useSelector(state => state.reducerPaymentTransaction.Payment);
    const reducerBooking = useSelector(state => state.reducerBooking);

    let payMultipleBookings = reducerBooking.booking && reducerBooking.booking.length > 1;

    useEffect(() => {
        if (props.mmbHasPaid && transaction.hasOwnProperty('Products') == false) {
            onClickHandler();
        }
    }, []);


    const onClickHandler = () => {
        actionResetBookingTypes(dispatch);
        props.onClickHandler()
    }

    const ShowWebDisplayName = (bookingID) => {
        // if (!tourEvent || tourEvent || tourEvent.BookingTypeID === undefined) { return ''; }
        //  const bookType = bookingTypes.filter(x => x.BookingTypeID == tourEvent.BookingTypeID)[0];
        //  return bookType ? tourEvent.EventName : '';
        const booking = reducerBooking.booking.filter(x => x.BookingID == bookingID)[0];
        return booking.BookingName.split("Event:")[1] ?
            booking.BookingName.split("Event:")[1] : booking.BookingName;

    }

    const groupbyBooking = () => {
        let products = [];
        transaction.Products.filter(x => x.Quantity > 0).map(item => {
            let itemobj = products.find(x => x.BookingID == item.BookingID);
            if (itemobj == null || itemobj == undefined) {
                if (item.BookingID !== undefined) {
                    products.push(item);
                }
            }
        })

        return products;
    }

    const GetGiftCards = () => {
        let giftcards = transaction.Products.filter(x => x.Giftcards && x.Giftcards.length > 0);
        return giftcards;
    }

    const getEvent = (toureventid) => {
        if (toureventid)
            return transaction.Events.find(x => x.TourEventID == toureventid)
    }

    const VisibleStartAndEndTime = (bookingID) => {

        let time = "";
        // if (tourEvent === undefined || tourEvent.BookingTypeID === undefined) {
        //     return '';
        // }

        const booking = reducerBooking.booking.filter(x => x.BookingID == bookingID)[0];
        const bookType = bookingTypes.filter(x => x.BookingTypeID == booking.BookingTypeID)[0];

        if (bookType) {
            if (bookType.ShowStartTime && bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(booking.EventStartDateTime) + ' - ' + Moment(booking.EventEndDateTime).format('hh:mm a');
            }

            if (bookType.ShowStartTime && !bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(booking.EventStartDateTime);
            }

            if (!bookType.ShowStartTime && bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormat(booking.EventEndDateTime);
            }

            if (!bookType.ShowStartTime && !bookType.ShowEndTime) {
                time += genfunction.GetEventDateReceiptFormatwithoutTime(booking.EventStartDateTime);
            }
        }

        return time;
    }

    const TotalPaid = () => {
        let total = 0;
        if (transaction) {
            if (transaction.Payments && transaction.Payments.length > 0) {
                total = transaction.Payments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0);
            }

            if ((props.refundType === 'GiftCardRefund' || props.refundType === 'CancelGiftCardRefund') && transaction.Products && transaction.Products.length > 0 && transaction.Products.filter(x => x.Giftcards !== undefined).length > 0) {
                total -= transaction.Products.filter(x => x.Giftcards !== undefined).map(({ LinePriceIncTax }) => LinePriceIncTax).reduce((sum, i) => sum + i, 0);
            }
        }

        return total;
    }

    const GetTourName = () => {
        let tourname = "";

        if (Payment.Events && Payment.Events.length > 0) {
            tourname = Payment.Events[0].EventName;
        }

        if (tourname.length < 1 && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty("BookingName")) {
            tourname = reducerBooking.booking[0].BookingName;
        }

        return tourname;
    }

    const GetTourDetails = () => {
        let tourdetails = "";
        let bookingID = reducerBooking.booking[0] ? reducerBooking.booking[0].BookingTypeID : 0;

        if (Payment.Events && Payment.Events.length > 0) {
            bookingID = Payment.Events[0].BookingTypeID;
        }

        if (transaction && transaction.Products && transaction.Events.length > 0 && transaction.Events.filter(x => x.BookingTypeID === bookingID).length > 0) {
            tourdetails = transaction.Events.filter(x => x.BookingTypeID === bookingID)[0].EventStartDateTime;
        }

        if (transaction && transaction.Products && transaction.Events.length < 1 && reducerBooking.booking[0].hasOwnProperty('EventStartDateTime')) {
            tourdetails = reducerBooking.booking[0].EventStartDateTime;
        }

        return tourdetails;
    }

    const GetBookingPrevPaid = () => {
        let bookingPaid = 0;

        if (reducerBooking.booking && reducerBooking.booking[0] && reducerBooking.booking[0].BookingPayments && reducerBooking.booking[0].BookingPayments.length > 0) {
            bookingPaid = reducerBooking.booking[0].BookingPayments.map(({ PaymentAmount }) => PaymentAmount).reduce((sum, i) => sum + i, 0)
        }

        return bookingPaid;
    }

    const totalPaidOfAllBookings = () => {

        return reducerBooking.booking.reduce((sumA, itemA) => {
            let totalB = itemA.hasOwnProperty('BookingPayments') && itemA.BookingPayments.reduce((sumB, itemB) => sumB + itemB.PaymentAmount, 0);
            return sumA + totalB;

        }, 0)
    }

    if (transaction.hasOwnProperty('Products') == false)
        return ("");
    else {

        let amounts = genfunction.GetProdsTotalAmount(transaction.Products)

        return (

            //Desktop and Laptop (smDown)
            //Tablet (xsDown mdUp)
            //Mobile (smUp)

            <div className={classes.center + " " + (!isshow ? classes.diplaynone : "")}>
                <div className={classes.textaligncenter}>
                    <CheckCircleOutlineOutlined style={{ fontSize: 80, fontWeight: "lighter", color: theme.palette.success.main }}></CheckCircleOutlineOutlined>
                    <Typography display="block" color="primary" gutterBottom={true} variant="h4" component="h4">{TransactionCompleteTitle}</Typography>
                    <Typography display="block" gutterBottom={true} variant="h4" component="h4" style={{ marginBottom: "30px" }}>Thank you {transaction.Customer.FirstName + " " + transaction.Customer.LastName}!</Typography>
                    <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{ConfirmationReceiptMessage}</Typography>
                    <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{transaction.Customer.CustomerAddress[0].Email}</Typography>

                    {Payment && Payment.hasOwnProperty('isCancelBooking') === false && reducerBooking.booking[0] && reducerBooking.booking[0].BookingID ?
                        <div>
                            <Typography display="block" gutterBottom={true} variant="h4" component="h4">
                                {"Booking ID " + (payMultipleBookings ? (reducerBooking.booking.map(i => i.BookingID).join(', ')) : reducerBooking.booking[0].BookingID) + " "}
                                {BookingSuccessfullyUpdate}</Typography>
                        </div>
                        : null
                    }


                    <Card style={{ borderRadius: "0px" }} >
                        <CardHeader className={classes.headerbox}
                            action={<Typography variant="h5" className={classes.headertext} color="inherit" component="h5">Receipt # {transaction.ReceiptNo}</Typography>}
                            title={"Transaction Summary"}
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent>
                            <Grid container>
                                <Grid item xs={12} style={{ textAlign: "left" }}>
                                    <Table>
                                        <TableRow >
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Booking # : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }} >
                                                <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">

                                                    {payMultipleBookings ? (reducerBooking.booking.map(i => i.BookingID).join(', ')) :
                                                        (reducerBooking.booking[0] ? reducerBooking.booking[0].BookingID : 0)}

                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Receipt Date and Time : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">{genfunction.GetTransactionDate(transaction.TransactionDate)}</Typography>
                                            </TableCell>
                                        </TableRow>
                                        {/* <TableRow >
                                            <TableCell className={classes.ReceiptTableCell}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Receipt Number : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell}><Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">{transaction.ReceiptNo}</Typography></TableCell>
                                        </TableRow> */}

                                        {payMultipleBookings === false &&
                                            <>
                                                <TableRow>
                                                    <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                        <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Tour Name : </Typography>
                                                    </TableCell>
                                                    <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                        <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">{GetTourName()}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                        <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Tour Details : </Typography>
                                                    </TableCell>
                                                    <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                        <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">{genfunction.GetTransactionDate(GetTourDetails())}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        }

                                        <TableRow >
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">New Cost : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">
                                                    {genfunction.ccyFormat(
                                                        payMultipleBookings ? (Math.abs(TotalPaid()) + Math.abs(totalPaidOfAllBookings())) :
                                                            (TotalPaid() > 0 ? Math.abs(TotalPaid()) + Math.abs(GetBookingPrevPaid()) : Math.abs(GetBookingPrevPaid()) - Math.abs(TotalPaid())))}</Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Previously Paid : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">
                                                    {genfunction.ccyFormat(payMultipleBookings ? totalPaidOfAllBookings() : GetBookingPrevPaid())}</Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '30%' }}>
                                                <Typography variant="h5" gutterBottom={true} color="inherit" component="h5">Amount Difference : </Typography>
                                            </TableCell>
                                            <TableCell className={classes.ReceiptTableCell} style={{ width: '70%' }}>
                                                <Typography variant="h5" className={classes.receiptfileds} gutterBottom={true} color="inherit" component="h5">
                                                    {genfunction.ccyFormat(TotalPaid())}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card style={{ borderRadius: "0px" }}>
                        <CardHeader className={classes.headerbox}
                            title={BookingTypeBarcodeHeader}
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent style={{ textAlign: "center" }}>
                            {
                                groupbyBooking().length > 0 ? groupbyBooking().map(item => (

                                    <div>

                                        <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{ShowWebDisplayName(item.BookingID)}</Typography>
                                        <Typography display="block" gutterBottom={true} variant="subtitle2" component="p">{VisibleStartAndEndTime(item.BookingID)}</Typography>
                                        <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=\\' + item.BookingID + "&includeLable=" + ShowReadableBarcode} />
                                    </div>
                                ))
                                    : null
                            }

                            {
                                GetGiftCards().length > 0 ? GetGiftCards().map(giftcard => (
                                    giftcard.Giftcards.map(gc => (
                                        <div>
                                            <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">{giftcard.ProductName}</Typography>
                                            <img className={classes.image} alt="Logo" src={DataAccess.apiUrl + 'Barcode/?barcode=' + gc.GiftcardNo + "&includeLable=" + ShowReadableBarcode} />
                                        </div>
                                    ))
                                )) : null
                            }

                        </CardContent>
                        {
                            props.refundType === '' && ((amounts.totalExclTax + amounts.totalExclTax + amounts.totalExclTax) === 0) ?
                                <CardContent style={{ textAlign: "center" }}>
                                    <div>
                                        <Typography display="block" gutterBottom={true} variant="h4" component="h4">Thank You</Typography>
                                        <Typography display="block" gutterBottom={true} variant="h5" component="h5">Amount Paid was {genfunction.ccyFormat(0)}</Typography>
                                        <Typography display="block" gutterBottom={true} variant="h5" component="h5">No Refund is due.</Typography>
                                    </div>
                                </CardContent>
                                : null
                        }

                        {Payment && Payment.hasOwnProperty('Products') && Payment.Products.length > 0 ?
                            <CardContent style={{ textAlign: "center" }}>
                                {
                                    Payment.Products.filter(x => x.Giftcards).map(item => (

                                        <div>
                                            <Typography display="block" gutterBottom={true} variant="h4" component="h4">Gift Card Number # </Typography>
                                            <Typography display="block" gutterBottom={true} variant="h5" component="h5" >{item.Giftcards[0].GiftcardNo}</Typography>

                                            <Typography display="block" gutterBottom={true} variant="h4" component="h4" >Balance Available</Typography>
                                            <Typography display="block" gutterBottom={true} variant="h5" component="h5" >{genfunction.ccyFormat(item.Giftcards[0].TotalBalance)}</Typography>

                                        </div>
                                    ))
                                }

                            </CardContent> : null}

                        {Payment && Payment.hasOwnProperty('isCancelBooking') && Payment.isCancelBooking ?
                            <CardContent style={{ textAlign: "center" }}>
                                {
                                    Payment && Payment.hasOwnProperty('isCancelBooking') && Payment.isCancelBooking ?
                                        <div>
                                            {Payment.hasOwnProperty('BookingID') ?
                                                <Typography display="block" gutterBottom={true} variant="h4" component="h4">Booking ID {Payment.BookingID} {BookingCancelMsg}</Typography>
                                                : null}
                                        </div>
                                        : null
                                }

                            </CardContent>
                            : null}

                        <CardContent style={{ textAlign: "center" }}>
                            <Typography display="block" gutterBottom={true} style={{ marginTop: "30px" }} variant="subtitle1" component="p">{CustomMessageforconfirmpage}</Typography>
                            <Button style={{ marginTop: 10 }} variant="contained" color="primary" onClick={onClickHandler}>
                                OK
                            </Button>
                        </CardContent>
                    </Card>

                </div>
            </div >

        );
    }
};

PaymentCompletePage.propTypes = {
    isshow: PropTypes.bool.isRequired,
    transaction: PropTypes.object.isRequired
};

export default PaymentCompletePage;
